/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ShieldLockIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABaklEQVR4nK2VyUrEQBCG8wpuo2+gB5cXcAHxICZdVS10qjKMb+GMCD6RG6IeXJiT+hjictSTwlxmwJGMghq7M9kK/ktS/X/d+auJ5+WoIIjGY+VZk82YohVAbgPJx0DI7fhZFcaLgHIGJH2rUG4RI1XIWJFcO42LgtaNmQCUy8zG9FeK+CI1I0A5KmoOP5ADN4CkUxYAJJ00QL8KeQUAvQB5W+tGLZZCaSnkboUAbv7v5WZugCJ5twanZDLZu2HMlGMzb2mAB9sirRs160hb7wTfuwHI59YToLSSvXEmjjE9dQKAZM8O4K5C3kmY9+wA2XUDwExnGT9I6Qk2oxkn4DuHu8IA5JtU869ThGsuA6KtsViu90rL6lDAAIJykvf2KuJjL2v5fn3ENbJgD/Y595/O1+ECEL8OBaC8INbnvCKllMwDyVNKqI++Dme9MmWMGQXiQ8vO9+NPWcr8dwGEy4B8FQuRlyozLlufFa8npUhuqHgAAAAASUVORK5CYII=)
 */
export const ShieldLockIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M4.56 4.22A2.83 2.83 0 0 0 3 6.75v3.03c0 5.6 3.3 10.69 8.42 12.96.37.17.79.17 1.16 0A14.18 14.18 0 0 0 21 9.78V6.75c0-1.07-.6-2.05-1.56-2.53l-6.1-3.05a3 3 0 0 0-2.68 0l-6.1 3.05ZM15 11a3 3 0 0 1-2 2.83v2.67a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-2.67A3 3 0 1 1 15 11Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
